export function isValidated(state){
    return !!state;
}